module.exports = __webpack_public_path__ + "img/banner-txt.5e420b4d.png";